import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './_nath_silva_fisiculturismo.module.scss';

/** Ordem natural 1–17 (evita sort alfabético 1, 10, 2…) */
const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/fisioculturismo/fisiculturismo1.png'), label: '01' },
    { src: require('./src/fisioculturismo/fisiculturismo2.png'), label: '02' },
    { src: require('./src/fisioculturismo/fisiculturismo3.png'), label: '03' },
    { src: require('./src/fisioculturismo/fisiculturismo4.png'), label: '04' },
    { src: require('./src/fisioculturismo/fisiculturismo5.png'), label: '05' },
    { src: require('./src/fisioculturismo/fisiculturismo6.png'), label: '06' },
    { src: require('./src/fisioculturismo/fisiculturismo7.png'), label: '07' },
    { src: require('./src/fisioculturismo/fisiculturismo8.png'), label: '08' },
    { src: require('./src/fisioculturismo/fisiculturismo9.png'), label: '09' },
    { src: require('./src/fisioculturismo/fisiculturismo10.png'), label: '10' },
    { src: require('./src/fisioculturismo/fisiculturismo11.png'), label: '11' },
    { src: require('./src/fisioculturismo/fisiculturismo12.png'), label: '12' },
    { src: require('./src/fisioculturismo/fisiculturismo13.png'), label: '13' },
    { src: require('./src/fisioculturismo/fisiculturismo14.png'), label: '14' },
    { src: require('./src/fisioculturismo/fisiculturismo15.png'), label: '15' },
    { src: require('./src/fisioculturismo/fisiculturismo16.png'), label: '16' },
    { src: require('./src/fisioculturismo/fisiculturismo17.png'), label: '17' },
];

const _nath_silva_fisiculturismo: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles._nath_silva_fisiculturismo}>
            <div className={styles.page}>
                <header className={styles.header}>
                    <Link
                        to="/_nath_silva"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao link na bio"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Nathalia Silva</p>
                        <h1 className={styles.title}>Fisiculturismo</h1>
                    </div>
                </header>

                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Fisiculturismo — Nathalia Silva, imagem ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default _nath_silva_fisiculturismo;
